import { render } from "./TableEmpty.vue?vue&type=template&id=201383d1&ts=true&class=table-empty"
import script from "./TableEmpty.ts?vue&type=script&lang=ts&external"
export * from "./TableEmpty.ts?vue&type=script&lang=ts&external"

import "./TableEmpty.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__